var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.active)?_c('div',{staticClass:"bg-black bg-opacity-75 fixed inset-0 z-10000 m-0 p-2 md-lg:p-6 flex justify-center",on:{"click":function($event){$event.stopPropagation();_vm.canClose ? _vm.close() : null}}},[_c('div',{staticClass:"modal flex justify-center max-h-full my-auto relative w-full bg-white shadow rounded md-lg:rounded-lg",class:[
        {
          'flex-col md-lg:flex-row h-full md-lg:h-auto': _vm.split,
          'lock-aspect-ratio': _vm.lockAspectRatio && !_vm.small,
          'px-4 py-5': _vm.padded,
          'modal-small': _vm.small,
        },
        _vm.padded ? (_vm.small ? 'pt-10 sm:p-10' : 'sm:p-6') : '',
        _vm.yScrollClass,
      ],on:{"click":function($event){$event.stopPropagation();return (() => {}).apply(null, arguments)}}},[_vm._t("default"),_vm._v(" "),(_vm.canClose)?_c('CloseButton',{staticClass:"right-2 top-2 -mr-0.5 -mt-0.5",nativeOn:{"click":function($event){return _vm.close.apply(null, arguments)}}}):_vm._e()],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }